
export default {
    props: {
        classes: {
            type: String,
            default: '',
        },
        containerClasses: {
            default: 'container mx-auto',
            type: String,
        },
    },

    render(h) {
        return h('section', { class: ['loverly-section', this.classes] }, [
            h(
                'div',
                {
                    class: this.containerClasses,
                },
                [this.$slots.default]
            ),
        ])
    },
}
